<template>
  <div class="expert-cert-page" v-loading="pageLoading">
    <div class="expert-cert-shell">
      <div class="cert-card">
        <div class="card-header" @click="goBack">
          <i class="el-icon-arrow-left"></i> <span>返回</span>
        </div>
        <h1 class="cert-title">专家认证</h1>
        <div class="cert-desc">请填写真实、有效的认证信息</div>

        <el-form
          ref="formRef"
          :model="form"
          class="cert-form"
          label-width="90px"
          label-position="right"
        >
          <el-form-item label="真实姓名" required>
            <el-input
              v-model.trim="form.realName"
              placeholder="请输入您的真实姓名"
              maxlength="30"
              clearable
            />
          </el-form-item>

          <el-form-item label="手机号码" required>
            <el-input
              v-model.trim="form.phone"
              placeholder="请输入您的手机号码"
              maxlength="20"
              clearable
            />
          </el-form-item>

          <el-form-item label="所在单位" required>
            <el-input
              v-model.trim="form.expertHospital"
              placeholder="请输入您的所在单位"
              maxlength="80"
              clearable
            />
          </el-form-item>

          <el-form-item label="科室" required>
            <el-input
              v-model.trim="form.expertPosition"
              placeholder="请输入您的科室"
              maxlength="50"
              clearable
            />
          </el-form-item>

          <el-form-item label="职称" required>
            <el-input
              v-model.trim="form.expertOffice"
              placeholder="请输入您的职称"
              maxlength="50"
              clearable
            />
          </el-form-item>
        </el-form>

        <div class="submit-row">
          <button
            type="button"
            class="submit-btn"
            :disabled="submitting"
            @click="handleSubmit"
          >
            {{ submitting ? "提交中..." : "提交认证" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { httpRequest } from "@/axios/axios-api";

export default {
  name: "ExpertCertification",
  data() {
    return {
      pageLoading: false,
      submitting: false,
      form: {
        realName: "",
        phone: "",
        expertHospital: "",
        expertPosition: "",
        expertOffice: ""
      }
    };
  },
  methods: {
    validateForm() {
      if (!this.form.realName) {
        this.$message.warning("请输入您的真实姓名");
        return false;
      }
      if (!this.form.phone) {
        this.$message.warning("请输入您的手机号码");
        return false;
      }
      if (!this.form.expertHospital) {
        this.$message.warning("请输入您的所在单位");
        return false;
      }
      if (!this.form.expertPosition) {
        this.$message.warning("请输入您的科室");
        return false;
      }
      if (!this.form.expertOffice) {
        this.$message.warning("请输入您的职称");
        return false;
      }
      return true;
    },
    async handleSubmit() {
      if (this.submitting) {
        return;
      }
      if (!this.validateForm()) {
        return;
      }

      this.submitting = true;
      try {
        const payload = {
          realName: this.form.realName,
          phone: this.form.phone,
          expertHospital: this.form.expertHospital,
          expertPosition: this.form.expertPosition,
          expertOffice: this.form.expertOffice
        };
        const res = await httpRequest("/app/user/zhuanjia", "put", payload);
        if (res && res.code === 200) {
          this.$message.success("您已提交，请等待审核");
          this.goBack();
          return;
        }
      } catch (error) {
        void error;
      } finally {
        this.submitting = false;
      }
    },
    goBack() {
      if (window.history.length > 1) {
        this.$router.back();
        return;
      }
      this.$router.push("/expert");
    }
  }
};
</script>

<style scoped lang="scss">
.expert-cert-page {
  min-height: calc(100vh - 170px);
  padding: 48px 0 56px;
  background: #f5f7fa;
}

.expert-cert-shell {
  width: 600px;
  max-width: 95%;
  margin: 0 auto;
}

.cert-card {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  padding: 40px 60px 50px;
  position: relative;
}

.card-header {
  position: absolute;
  top: 34px;
  left: 40px;
  display: inline-flex;
  align-items: center;
  font-size: 15px;
  color: #515a67;
  cursor: pointer;
  transition: color 0.2s ease;

  i {
    font-size: 18px;
    margin-right: 4px;
  }

  &:hover {
    color: #3f93dc;
  }
}

.cert-title {
  margin: 0 0 8px;
  font-size: 26px;
  font-weight: 600;
  line-height: 1.4;
  color: #1f2530;
  text-align: center;
}

.cert-desc {
  text-align: center;
  color: #8e99a6;
  font-size: 14px;
  margin-bottom: 30px;
}

.cert-form {
  text-align: left;

  ::v-deep .el-form-item {
    margin-bottom: 24px;
  }

  ::v-deep .el-form-item__label {
    font-size: 15px;
    line-height: 48px;
    color: #344054;
    font-weight: 500;
    padding-right: 16px;
  }

  ::v-deep .el-input__inner {
    height: 48px;
    line-height: 48px;
    border-color: #e4e7ed;
    border-radius: 6px;
    font-size: 15px;
    color: #1f2530;
    padding: 0 16px;
    transition: all 0.2s;

    &:focus {
      border-color: #3f93dc;
      box-shadow: 0 0 0 2px rgba(63, 147, 220, 0.15);
    }
  }

  ::v-deep .el-input__inner::placeholder {
    color: #acb4c0;
    font-size: 14px;
  }
}

.submit-row {
  display: flex;
  justify-content: center;
  margin-top: 40px;
}

.submit-btn {
  width: 260px;
  height: 48px;
  border: none;
  border-radius: 24px;
  background: #3f93dc;
  color: #ffffff;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  letter-spacing: 2px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(63, 147, 220, 0.3);

  &:hover {
    background: #50a1e8;
    box-shadow: 0 6px 16px rgba(63, 147, 220, 0.4);
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(1px);
    box-shadow: 0 2px 6px rgba(63, 147, 220, 0.2);
  }

  &:disabled {
    cursor: not-allowed;
    background: #a0cfff;
    box-shadow: none;
    transform: none;
  }
}

@media (max-width: 600px) {
  .cert-card {
    padding: 40px 24px 40px;
  }

  .card-header {
    top: 20px;
    left: 20px;
    font-size: 14px;

    i {
      font-size: 16px;
    }
  }
}
</style>
